import Vue from "vue";
import Cookies from "js-cookie";
// import iview from "iview";
import viewDesign from "view-design";
import { mapGetters } from 'vuex';
import vviewTobog, { directives } from "vview-tobog";
import Webfs from './utils/webfs';
import { conversionUnit, userBrowser, extendStorage, syncSessionStorage, initEnvPrefix, updateVersion, handleHostname, handleCopy } from './utils/tools';
import Notify from './utils/notify';
import initComponent from './components/templates/index';
import langMap from "./locale/langmap";
import { LogoutBase } from './service/base';
import Dates from '@mods/utils/date';

import recode from './utils/recode';
// import "iview/dist/styles/iview.css";
import 'view-design/dist/styles/iview.css';
//必须先初始化global.SYSID
global.SYSID = JSON.parse(Cookies.get("organization") || '{}').id;
global.DOMAIN = handleHostname('.onepinnovate.com');
//初始化环境前缀
initEnvPrefix(process.env.VUE_APP_HOST_PREFIX);
//扩展storage
extendStorage();
//同步storage
syncSessionStorage();
//是否版本更新
updateVersion(LogoutBase);//必须先初始化global.SYSID

recode();

const bus = new Vue()
Vue.prototype.bus = bus

initComponent(Vue);
// Vue.use(iview);
Vue.use(viewDesign);
Vue.use(vviewTobog, { alias: 'v', prefix: 'vview', langMap });
Vue.mixin({
    directives,
    methods: {
        async handleWebfs(request, data, options = "download") {
            if (!data || typeof data !== "object") data = {};
            if (!options || typeof options !== "object")
                options = { executor: options || "download" };
            let executor = options.executor;
            if (typeof request === "function") {
                options[executor] = true;
                executor = "request";
            }
            switch (executor) {
                case "download":
                case "print":
                    break;
                default:
                    executor = "request";
                    break;
            }
            Notify();
            const promise = Promise.resolve(
                Webfs[executor](
                    request,
                    {
                        contextId: global.SYSID,
                        lang: global.LANG,
                        // Authorization: global.AUTH_TOKEN,
                        // token: global.AUTH_TOKEN,
                        ...data
                    },
                    options
                )
            );
            return promise
                .then(res => {
                    return Promise.resolve(res);
                })
                .catch(err => {
                    Notify(undefined, err.message);
                    if (err.code == 200) {
                        if (data.showmessage != 'no') {
                            this.$VMessage.success(err.message);
                        }
                        return Promise.resolve(err);
                    }
                    this.$VMessage.error(err.message);
                    return Promise.reject(err);
                });
        },
        handleAuth(auth) {
            return this.getAuthList.indexOf(auth) > -1;
        },
        /**
         *
         * @param {} params=7
         * @description 前几天日期区间
         */
        handleDateRange(params = 7) {
            const now = new Date(),
                pre = new Date();
            pre.setDate(pre.getDate() - params + 1);
            const zorePrefix = function (val) {
                return val - 9 > 0 ? val : `0${val}`;
            };
            return [
                `${pre.getFullYear()}-${zorePrefix(
                    pre.getMonth() + 1
                )}-${zorePrefix(pre.getDate())}`,
                `${now.getFullYear()}-${zorePrefix(
                    now.getMonth() + 1
                )}-${zorePrefix(now.getDate())}`
            ];
        },
        //用于columns 的 render显示
        findRenderLabel(data = [], value, key = "label", isTag = false) {
            var valKey = "value";
            if (Array.isArray(key)) {
                valKey = key[1] || "value";
                key = key[0] || "label";
            }
            const result = data.find(function (item, index) {
                return item && typeof item === "object"
                    ? item[valKey] == value
                    : index == value;
            });
            const isObj = result && typeof result === "object";
            if (isTag && isObj) {
                return (
                    <vTag
                        color={result.color || result.theme}
                        class="status-tag"
                        type="border"
                    >
                        {result[key]}
                    </vTag>
                );
            }
            return isObj ? result[key] : result;
        },
        // 单位换算
        handleUnit: conversionUnit,
        //处理浏览器提示
        handleUserBrowser: userBrowser,
        // 数组去重
        arrayUnique(arr, name) {
            var hash = {};
            return arr.reduce((item, next) => {
                hash[next[name]]
                    ? ""
                    : (hash[next[name]] = true && item.push(next));
                return item;
            }, []);
        },
        // 根据某个字段进行数组的排序
        compareAttribute(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        },
        // 获取时间指定天数
        getDay(day) {
            var today = new Date();
            var targetday_milliseconds =
                today.getTime() + 1000 * 60 * 60 * 24 * day;
            today.setTime(targetday_milliseconds); //注意，这行是关键代码
            var tYear = today.getFullYear();
            var tMonth = today.getMonth();
            var tDate = today.getDate();
            tMonth = this.doHandleMonth(tMonth + 1);
            tDate = this.doHandleMonth(tDate);
            return tYear + "-" + tMonth + "-" + tDate;
        },
        doHandleMonth(month) {
            var m = month;
            if (month.toString().length == 1) {
                m = "0" + month;
            }
            return m;
        },
        // 公共错误提示延迟30秒
        errorMessage(message) {
            this.$VMessage.error({
                content: message,
                duration: 30,
                closable: true
            });
        },
        //处理多域名问题
        handleHostname,
        // 处理copy,
        handleCopy(target, message = "已复制数据！") {
            if (typeof target === "string")
                target = document.querySelector(target) || target;
            if (target && handleCopy(target) && message) {
                this.$VMessage.success({ content: message, duration: 2 });
            }
        },
        // 跳转文档
        jumpHelp(href) {
            window.open(href);
            event.preventDefault();
        },
        // 增加千分位分隔符
        handleNumberSplit(number) {
            if (!number || number === 0 || number === "0") return number;
            // 是否负数
            let isNegative = false;
            switch (typeof number) {
                case "number":
                    if (number < 0) {
                        isNegative = true;
                    }
                    break;
                case "string":
                    if (number.indexOf("-") !== -1) {
                        isNegative = true;
                    }
                    break;
            }
            let numStrArr = String(Math.abs(number)).split(".");
            let count = 1;
            let intArr = numStrArr[0].split("");
            for (let i = intArr.length - 1; i >= 0; i--) {
                if (count == 3) {
                    // 边界情况，首位不需要添加,
                    if (i == 0) break;
                    count = 0;
                    let rest = intArr.splice(i);
                    intArr.push(",");
                    intArr = intArr.concat(rest);
                    i++;
                }
                else {
                    count++;
                }
            }
            let floatNum = numStrArr[1];
            let intNum = intArr.join("");
            let result = intNum;
            if (floatNum) {
                result = `${intNum}.${floatNum}`;
            }
            if (isNegative) result = "-" + result;
            return result;
        },
        // 日期修改展示
        handleDateFormat(date, format) {
            return Dates.stringify(date, format);
        },
        /**
         * 避免小数 和、差、积、商 出现浮点误差问题
         * point为需要处理的小数位数，默认4位小数
         */
        getCalculate(val1, val2, symbol = 1, point = 4) {
            let flag = 1;
            for (let i = 0; i < point; i ++) {
                flag = flag * 10;
            }
            let num1 = Math.floor(val1 * flag),
            num2 = Math.floor(val2 * flag);
            let result = 0;
            switch (symbol) {
                // 求和
                case 1:
                {
                    result = (num1 + num2) / flag;
                }
                break;
                // 求差
                case 2:
                {
                    result = (num1 - num2) / flag;
                }
                break;
                // 求积
                case 3:
                {
                    result = (num1 * num2) / (flag * flag);
                }
                break;
                // 求商
                case 4:
                {
                    result = (num1 / num2) * (flag * flag)
                }
                break;
            }
            return result;
        },
    },
    computed: {
        ...mapGetters("layout", ["getAuthList"]),
        //获取环境前缀
        getEnvPrefix() {
            return global.envPrefix;
        }
    }
});
